import React from 'react';
import { ArrowUpRight, Facebook, Instagram, Linkedin, Mail, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative pt-28 pb-16 px-6 bg-gradient-to-b from-white via-blue-50/40 to-blue-100/30 overflow-hidden">
      {/* Abstract Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30 z-0">
        <div className="absolute top-20 left-10 w-64 h-64 rounded-full bg-primary/10 blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 rounded-full bg-blue-400/10 blur-3xl"></div>
        <div className="absolute top-40 right-1/4 w-72 h-72 rounded-full bg-indigo-300/10 blur-3xl"></div>
      </div>

      <div className="container mx-auto relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          {/* Company Info */}
          <div className="relative">
            <div className="mb-8 flex items-center gap-3 group">
              <div className="relative">
                <div className="absolute inset-0 bg-primary/20 rounded-full blur-lg group-hover:blur-xl transition-all duration-500 opacity-70 group-hover:opacity-100"></div>
                <img
                  src="/images//d-logo.png"
                  alt="Dhansamuh Logo"
                  className="h-12 w-auto relative hover:scale-105 transition-transform duration-300"
                />
              </div>
              <span className="text-2xl font-display font-bold bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent">
                Dhansamuh
              </span>
            </div>
            <p className="text-foreground/70 mb-8 font-sans leading-relaxed text-lg">
              Empowering communities through secure, transparent and easy-to-use digital committees.
            </p>
            {/* <div className="flex space-x-4">
              {[
                { icon: Facebook, label: "Facebook" },
                { icon: Twitter, label: "Twitter" },
                { icon: Instagram, label: "Instagram" },
                { icon: Linkedin, label: "LinkedIn" }
              ].map((item, index) => (
                <a 
                  key={index}
                  href="#" 
                  className="p-3 rounded-full bg-white shadow-sm hover:shadow-md text-foreground/50 hover:text-primary transition-all duration-300 hover:scale-110" 
                  aria-label={item.label}
                >
                  <item.icon size={18} />
                </a>
              ))}
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-xl mb-8 text-gray-800">Quick Links</h3>
            <ul className="space-y-5">
              {['Features', 'How It Works', 'Testimonials', 'FAQ', 'Blog'].map((item) => (
                <li key={item}>
                  <a 
                    href={`#${item.toLowerCase().replace(' ', '-')}`} 
                    className="text-gray-600 hover:text-primary transition-colors duration-300 flex items-center group"
                  >
                    <span className="relative overflow-hidden inline-block pr-1">
                      <span className="relative z-10 font-medium">{item}</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
                    </span>
                    <ArrowUpRight size={14} className="ml-1 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-bold text-xl mb-8 text-gray-800">Legal</h3>
            <ul className="space-y-5">
              {['Terms of Service', 'Privacy Policy', 'Security', 'Compliance', 'Accessibility'].map((item) => (
                <li key={item}>
                  <a 
                    href="#" 
                    className="text-gray-600 hover:text-primary transition-colors duration-300 flex items-center group"
                  >
                    <span className="relative overflow-hidden inline-block pr-1">
                      <span className="relative z-10 font-medium">{item}</span>
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
                    </span>
                    <ArrowUpRight size={14} className="ml-1 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          {/* <div>
            <h3 className="font-bold text-xl mb-8 text-gray-800">Contact</h3>
            <ul className="space-y-5">
              <li className="flex items-center text-gray-600 group">
                <div className="mr-4 p-3 rounded-full bg-white shadow-sm group-hover:shadow-md group-hover:bg-primary/5 transition-all duration-300">
                  <Mail size={16} className="text-primary/70 group-hover:text-primary transition-colors duration-300" />
                </div>
                <a href="mailto:support@chitfund.app" className="hover:text-primary transition-colors duration-300 font-medium">support@chitfund.app</a>
              </li>
              <li className="flex items-start group">
                <div className="mr-4 p-3 rounded-full bg-white shadow-sm group-hover:shadow-md group-hover:bg-primary/5 transition-all duration-300 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary/70 group-hover:text-primary transition-colors duration-300">
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div className="text-gray-600">
                  <p className="leading-relaxed font-medium">123 Financial District</p>
                  <p className="leading-relaxed">Mumbai, India 400001</p>
                </div>
              </li>
            </ul>
            <div className="mt-8">
              <a 
                href="#" 
                className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-r from-primary to-primary/90 text-white font-medium hover:shadow-md hover:scale-105 transition-all duration-300"
              >
                Download App 
                <ArrowUpRight size={16} className="ml-2" />
              </a>
            </div>
          </div> */}
        </div>

        <div className="border-t border-gray-200/60 pt-10">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4 mb-4 md:mb-0">
              <p className="text-sm text-gray-500">
                © {new Date().getFullYear()} HFC Chits Pvt. Ltd. All rights reserved.
              </p>
              <div className="flex items-center text-sm text-gray-500">
                <span className="inline-flex items-center">Made with <span className="text-red-500 mx-1">❤️</span> in India</span>
              </div>
            </div>
            <div className="flex space-x-8">
              {['Terms', 'Privacy', 'Cookies'].map((item) => (
                <a 
                  key={item}
                  href="#" 
                  className="text-sm text-gray-500 hover:text-primary transition-colors duration-300 relative group"
                >
                  <span className="relative z-10">{item}</span>
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary/40 transition-all duration-300 group-hover:w-full"></span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;